import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import * as firebase from 'firebase/app';

interface Loan {
    active: number;
    authorizeId: string;
    authorizeName: string;
    createdAt: any;
    discountPerPayroll: number;
    employeeId: string;
    employeeName: string;
    loanAmount: number;
    loanDate: any;
    remainingAmount: number;
    updatedAt: any;
}

interface LoanId extends Loan {
    id: string;
}

interface Payment {
    amount: number;
    paymentDate: any;
    payrollId: string;
}

interface PaymentId extends Payment {
    id: string;
}

@Injectable()
export class LoanService {

    loanCollection: AngularFirestoreCollection<Loan>;
    loans: any;

    loanDocument: AngularFirestoreDocument<LoanId>;
    loan: Observable<LoanId>;

    loanCollectionBatch: any;

    paymentCollection: any;
    payments: any;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.LOAN_COLLECTION;
    }

    postLoan(loanObject: any) {
        this.loanCollection = this.afs.collection(this.collection);

        return this.loanCollection.add(loanObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
            return docRef.id;
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getLoans() {
        this.loanCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', 1).
            orderBy('loanDate', 'desc'));

        this.loans = this.loanCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Loan;

                const loanDate = data.loanDate;
                const authorizeId = data.authorizeId;
                const authorizeName = data.authorizeName;
                const employeeId = data.employeeId;
                const employeeName = data.employeeName;
                const loanAmount = data.loanAmount;
                const discountPerPayroll = data.discountPerPayroll;
                const remainingAmount = data.remainingAmount;

                return { id$, loanDate, authorizeId, authorizeName, employeeId, employeeName,
                         loanAmount, discountPerPayroll, remainingAmount };
            });
        }).map(object => object);

        return this.loans;
    }

    getLoan(id$: string) {
        this.loanDocument = this.afs.doc(this.collection + '/' + id$);

        this.loan = this.loanDocument.valueChanges();

        return this.loan.map(object => object);
    }

    putLoan(loanObject: any, id$: string) {
        this.loanCollection = this.afs.collection(this.collection);

        return this.loanCollection.doc(id$).update(loanObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    /*
    delLoan(id$: string) {
        this.loanDocument = this.afs.doc(this.collection + '/' + id$);

        return this.loanDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }
    */

    delLoan(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        this.loanCollection = this.afs.collection(this.collection);

        return this.loanCollection.doc(id$).update({ active: 0, updatedAt: new Date() }).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    getActiveLoans() {
        this.loanCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', 1).
                              where('remainingAmount', '>', 0));

        this.loans = this.loanCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Loan;

                const loanDate = data.loanDate;
                const employeeId = data.employeeId;
                const employeeName = data.employeeName;
                const loanAmount = data.loanAmount;
                const discountPerPayroll = data.discountPerPayroll;
                const remainingAmount = data.remainingAmount;

                return { id$, loanDate, employeeId, employeeName, loanAmount, discountPerPayroll, remainingAmount };
            });
        }).map(object => object);

        return this.loans;
    }

    putLoanAtomic(loans: any, payrollId: string) {
        const batch = firebase.firestore().batch();

        this.loanCollectionBatch = firebase.firestore().collection(this.collection);
        const currentDate = new Date();

        for (let item in loans) {
            const loanRef = this.loanCollectionBatch.doc(loans[item].id);
            const paymentRef = loanRef.collection('payment').doc(payrollId);

            batch.update(loanRef, { remainingAmount: (loans[item].remaining - loans[item].payment), updatedAt: currentDate });
            batch.set(paymentRef, { amount: loans[item].payment, paymentDate: currentDate, payrollId: payrollId });
        }

        return batch.commit();
    }

}
